import { getInjector, getRootScope } from '@/services/angularjs-bridge';
import { restUrl } from '@/services/utils';

declare const angular: { copy: <T>(value: T) => T };

interface OrganizationRecord {
    id?: number | string;
    name?: string;
    gln?: string;
    url?: string;
    email?: string;
    address?: string;
    localeSpecificNumberFormat?: boolean;
    hasImage?: boolean;
    imageUrl?: string;
    verified?: boolean;
    customValues?: Record<string, unknown>;
    [key: string]: unknown;
}

interface OrganizationSubscription {
    unsubscribe: () => void;
}

interface OrganizationServiceApi {
    $organization: {
        subscribe: (listener: (organization: OrganizationRecord) => void) => OrganizationSubscription;
    };
    getOrganization: (force?: boolean) => unknown;
    update: (data: Partial<OrganizationRecord>) => void;
}

interface OrganizationResourceApi {
    save: (
        params: Record<string, never>,
        data: OrganizationRecord,
        onSuccess: (response: OrganizationRecord) => void,
        onError: (response: { data?: unknown; status?: number }) => void,
    ) => void;
}

interface RootScopeApi {
    prepareAttributes: (attributes: unknown[]) => void;
    dataModel: {
        getOrganizationAttributes: () => unknown[];
    };
    $broadcast: (name: string) => void;
    error?: unknown;
}

function cloneOrganization(organization: OrganizationRecord): OrganizationRecord {
    return angular.copy(organization);
}

function organizationBridge() {
    const injector = getInjector();
    return {
        rootScope: getRootScope(injector) as RootScopeApi,
        organizationService: injector.get('OrganizationService') as OrganizationServiceApi,
        organizationResource: injector.get('OrganizationResource') as OrganizationResourceApi,
    };
}

function organizationImageUrl() {
    return restUrl('organization/image');
}

export {
    cloneOrganization,
    organizationBridge,
    organizationImageUrl,
};
export type { OrganizationRecord };
